import {CurrentProblemsWidget} from "./widgets/current-problems";

export const widgets = {
  "zabbix:current-problems": CurrentProblemsWidget,
};
